import { cols } from "@/config/system";
import { momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    fixed: true,
    disabled: true,
    width: cols.number,
  },
  {
    label: "对账客户名称",
    prop: "customerName",
  },
  {
    label: "项目客户",
    prop: "contractProjectName",
  },
  {
    label: "合同主体",
    prop: "contractSubject",
  },
  {
    label: "网点名称",
    prop: "siteName",
  },
  {
    label: "结款周期",
    prop: "accountCycleShow",
  },
  {
    label: "结款日",
    prop: "borrowingDate",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD"),
  },
  {
    label: "账单日期",
    prop: "billDate",
  },
  {
    label: "发件票数",
    prop: "billCount",
  },
  {
    label: "结算重量",
    prop: "accountWeight",
  },
  {
    label: "运费",
    prop: "tranFee",
  },
  {
    label: "理赔费用",
    prop: "claimsFee",
  },
  {
    label: "加收费用",
    prop: "claimsAddFee",
  },
  {
    label: "跨期结算费用",
    prop: "crossSettlementFee",
  },
  {
    label: "应付总额",
    prop: "totalFee",
  },
  {
    label: "已付/预付金额",
    prop: "hexiaoFee",
  },
  {
    label: "未付金额",
    prop: "expensesFee",
  },
  {
    label: "网点确认状态",
    prop: "siteCheckStatusName",
  },
  {
    label: "账单状态",
    prop: "customerCheckStatusShow",
  },
  {
    label: "调账申请已申请票数",
    prop: "applyTotal",
  },
  {
    label: "调账申请待处理票数",
    prop: "pendingTotal",
  },
  {
    label: "操作",
    fixed: "right",
    width: cols.huge,
    slotName: "actions",
  },
];
